import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M13.6736 5H3.65972C2.74306 5 2 5.74306 2 6.65972V16.6736C2 17.5903 2.74306 18.3333 3.65972 18.3333H13.6736C14.5903 18.3333 15.3333 17.5903 15.3333 16.6736V6.65972C15.3333 5.74306 14.5903 5 13.6736 5ZM20.25 6.30903L16.4444 8.93403V14.3993L20.25 17.0208C20.9861 17.5278 22 17.0104 22 16.125V7.20486C22 6.32292 20.9896 5.80208 20.25 6.30903Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Video"
);
